import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { saveStaffAccess } from "../Redux/Action";
import Loader from "../Loader";
import Heading from "../Common/Heading";

function TeamAccessPopup({
	setToggleMenu,
	defaultAccessKeys,
	staffAccessKey,
	staffId,
}) {
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(false);
	const [accessKeysState, setAccessKeysState] = useState(() => {
		const validStaffAccessKey = staffAccessKey || {};
		const initialState = {};
		// Handle the nested structure of defaultAccessKeys
		if (defaultAccessKeys?.accessKeys) {
			Object.entries(defaultAccessKeys.accessKeys).forEach(
				([section, keys]) => {
					Object.keys(keys).forEach((key) => {
						initialState[key] = validStaffAccessKey[key] || 0;
					});
				}
			);
		}
		return initialState;
	});

	const handleChange = (key) => {
		setAccessKeysState((prevState) => ({
			...prevState,
			[key]: prevState[key] === 1 ? 0 : 1,
		}));
	};

	const onAccessFormSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);
		const responds = await dispatch(
			saveStaffAccess(staffId, { ...accessKeysState })
		);
		if (responds) {
			setToggleMenu(false);
		}
	};

	return (
		<div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 animated fadeInDown min-h-screen overflow-auto">
			<div className="w-full max-w-sm sm:max-w-md md:max-w-2xl bg-white shadow-lg rounded-lg p-6 relative mx-auto border-2 flex flex-col max-h-[90vh]">
				<Heading title="Team Access" />
				<hr className="my-2" />
				<div className="flex-1 overflow-y-auto px-2">
					<div className="grid grid-cols-1 gap-4 p-4">
						{defaultAccessKeys?.accessKeys &&
							Object.entries(defaultAccessKeys.accessKeys).map(
								([section, keys]) => (
									<div key={section} className="mb-4">
										<h3 className="font-semibold mb-2 text-lg">
											{section === "0" ? "General Access" : "Hotel Access"}
										</h3>
										<div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
											{Object.entries(keys).map(([key, label]) => (
												<div key={key} className="flex items-center space-x-2">
													<input
														type="checkbox"
														id={key}
														checked={accessKeysState[key] === 1}
														onChange={() => handleChange(key)}
														className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring focus:ring-blue-200"
													/>
													<label htmlFor={key} className="text-gray-700">
														{label}
													</label>
												</div>
											))}
										</div>
									</div>
								)
							)}
					</div>
				</div>
				<div className="flex justify-center mt-4 border-t pt-5">
					<button
						type="button"
						className="bg-gray-500 text-white px-10 py-2 rounded mr-2"
						onClick={() => setToggleMenu(false)}
					>
						Cancel
					</button>
					<button
						type="button"
						className="bg-primary text-white px-10 py-2 rounded"
						onClick={onAccessFormSubmit}
					>
						Update
					</button>
				</div>
			</div>
			{loading && <Loader />}
		</div>
	);
}

export default TeamAccessPopup;
